var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.506,
    viewBox: "0 0 21.5 21.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.244)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1522",
    "data-name": "Ellipse 1522",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(6 1.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42742",
    "data-name": "Path 42742",
    d: "M17.5,13.938A3.563,3.563,0,1,0,21.063,17.5,3.564,3.564,0,0,0,17.5,13.938Zm0,1.5A2.063,2.063,0,1,1,15.437,17.5,2.064,2.064,0,0,1,17.5,15.438Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42743",
    "data-name": "Path 42743",
    d: "M18.25,14.687V13a.75.75,0,0,0-1.5,0v1.688a.75.75,0,1,0,1.5,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42744",
    "data-name": "Path 42744",
    d: "M20.019,16.042l1.193-1.194a.75.75,0,0,0-1.06-1.06l-1.194,1.193a.75.75,0,1,0,1.061,1.061Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42745",
    "data-name": "Path 42745",
    d: "M20.312,18.25H22a.75.75,0,0,0,0-1.5H20.312a.75.75,0,0,0,0,1.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42746",
    "data-name": "Path 42746",
    d: "M18.958,20.019l1.194,1.193a.75.75,0,0,0,1.06-1.06l-1.193-1.194a.75.75,0,1,0-1.061,1.061Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42747",
    "data-name": "Path 42747",
    d: "M16.75,20.312V22a.75.75,0,0,0,1.5,0V20.312a.75.75,0,0,0-1.5,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42748",
    "data-name": "Path 42748",
    d: "M14.981,18.958l-1.193,1.194a.75.75,0,0,0,1.06,1.06l1.194-1.193a.75.75,0,0,0-1.061-1.061Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42749",
    "data-name": "Path 42749",
    d: "M14.687,16.75H13a.75.75,0,0,0,0,1.5h1.687a.75.75,0,1,0,0-1.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42750",
    "data-name": "Path 42750",
    d: "M16.042,14.981l-1.194-1.193a.75.75,0,0,0-1.06,1.06l1.193,1.194a.75.75,0,0,0,1.061-1.061Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42751",
    "data-name": "Path 42751",
    d: "M12.936,21.756a1.751,1.751,0,0,1,.145-2.311l.194-.195H13a1.75,1.75,0,0,1,0-3.5h.275l-.194-.195A1.75,1.75,0,0,1,13,13.164c-.49-.038-.992-.058-1.5-.058a14.882,14.882,0,0,0-8.089,2.076A4.281,4.281,0,0,0,1.25,18.606v1.45a1.7,1.7,0,0,0,1.7,1.7Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.8cbe60450d18ace64b45c9eab647b2eb.svg";
export { ForwardRef as ReactComponent };